var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 55,
    height: 55,
    transform: "translate(-0.394)",
    fill: "#f2f2f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_18",
    "data-name": "Mask Group 18",
    transform: "translate(0.394)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files-and-folders",
    transform: "translate(5.468 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M47.278,14.793,33.765,1.279A4.338,4.338,0,0,0,30.677,0H10.35A5.552,5.552,0,0,0,4.8,5.541V38.713a.8.8,0,0,0,1.6,0V5.541A3.948,3.948,0,0,1,10.35,1.6H30.677a2.747,2.747,0,0,1,.677.085V6.968a.8.8,0,0,0,1.6,0V2.735L45.818,15.6H35.366a2.413,2.413,0,0,1-2.41-2.41V10.707a.8.8,0,0,0-1.6,0v2.482A4.017,4.017,0,0,0,35.366,17.2h11.5a2.763,2.763,0,0,1,.082.669V49.149A3.948,3.948,0,0,1,43,53.088H10.35A3.948,3.948,0,0,1,6.4,49.149v-6.7a.8.8,0,0,0-1.6,0v6.7A5.552,5.552,0,0,0,10.35,54.69H43a5.552,5.552,0,0,0,5.551-5.541V17.871a4.324,4.324,0,0,0-1.275-3.077Z",
    transform: "translate(-4.799 0)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M20.966,30.3a3.106,3.106,0,1,0-3.106-3.106A3.109,3.109,0,0,0,20.966,30.3Zm0-4.61a1.5,1.5,0,1,1-1.5,1.5A1.505,1.505,0,0,1,20.966,25.688Z",
    transform: "translate(-2.979 3.357)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M14.589,21.464h1.723a.8.8,0,0,0,0-1.6H14.589a5.08,5.08,0,0,0-5.074,5.074V41.416a5.08,5.08,0,0,0,5.074,5.074H37.448a5.08,5.08,0,0,0,5.074-5.074V24.935a5.08,5.08,0,0,0-5.074-5.074h-17.4a.8.8,0,0,0,0,1.6h17.4a3.475,3.475,0,0,1,3.472,3.472V39.517l-7.105-9.908-.008-.011a2.674,2.674,0,0,0-4.157-.169l-1.268,1.446a.8.8,0,0,0,1.2,1.057l1.268-1.446a1.078,1.078,0,0,1,1.663.063l8.323,11.606a3.477,3.477,0,0,1-3.392,2.733H14.589a3.476,3.476,0,0,1-3.456-3.145l6.2-7.169a1.073,1.073,0,0,1,1.246.063l2.9,2.3a2.934,2.934,0,0,0,4.036-.363l1.606-1.832a.8.8,0,0,0-1.2-1.057L24.31,35.518a1.334,1.334,0,0,1-1.835.165l-2.9-2.3a2.675,2.675,0,0,0-3.263-.049c-.141.082-5.074,5.863-5.2,5.98V24.935a3.475,3.475,0,0,1,3.472-3.472Z",
    transform: "translate(-4.142 2.768)",
    fill: "#08c4bb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceImage);
export default __webpack_public_path__ + "static/media/service-image.b9c0a45b4c80db477611c37dde79c8d7.svg";
export { ForwardRef as ReactComponent };